import {
  AvatarGroup,
  Box,
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  styled,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { gridClasses, DataGridPro, GridFooterContainer } from '@mui/x-data-grid-pro';
import { Star, StarOutline } from '@mui/icons-material';

const ODD_OPACITY = 0.2;

export const DataTableSection = styled(Box)`
  width: 100%;
  min-width: 350px;
  padding-bottom: 15px;
`;

export const DataTableTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: 700;
  font-size: 20px;
`;

export const DataTableDropdown = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  padding: 40px 100px 20px 0;
`;

export const DataTableLabel = styled(Typography)`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text.secondary};
  text-transform: uppercase;
`;

export const DataTableFormControl = styled(FormControl)`
  height: 30px;
  border: none;
`;

export const DataTableSelect = styled(Select)`
  min-width: 247px;
  max-width: 580px;
  font-size: 14px;
  border: none;
  height: 30px;
  background-color: ${({ theme }) => theme.palette.action.selected};

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const DataTableMenuItem = styled(MenuItem)`
  font-size: 14px;
`;

export const DataTableWrapper = styled(Box)`
  height: 462px;
  width: 100%;
`;

export const DataTableGrid = styled(DataGridPro)`
  border: none;
  width: 100%;

  .MuiDataGrid-columnHeader {
    width: 100%;
    background-color: ${({ theme }) => theme.palette.action.disabledBackground};
  }

  .MuiDataGrid-columnHeaderTitle {
    font-weight: 800;
  }

  .MuiDataGrid-cell {
    display: flex;
    align-items: center;
  }

  .MuiDataGrid-cell:focus-within {
    outline: none;
  }

  .MuiDataGrid-cell:active {
    outline: none;
  }

  .MuiDataGrid-columnSeparator {
    display: none;
  }

  .MuiDataGrid-cell[data-field='name']:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .${gridClasses.row}.even {
    background-color: ${({ theme }) => alpha(theme.palette.action.disabledBackground, 0.05)};
  }

  .${gridClasses.row}:hover {
    background-color: ${({ theme }) =>
      alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.hoverOpacity)};
  }
`;

export const FavoriteHeaderWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const FavoriteButton = styled(Box)`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
`;

export const DataTableName = styled('span')`
  all: unset;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const DataTableFooterContainer = styled(GridFooterContainer)`
  justify-content: center;
  padding: 0;
  display: flex;
`;

export const DataTableButton = styled(Button)`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const LoadingButton = styled(CircularProgress)`
  display: flex;
  justify-content: center;
`;

export const FullStar = styled(Star)`
  cursor: pointer;
`;

export const EmptyStar = styled(StarOutline)`
  color: ${({ theme }) => theme.palette.text.primary};
  cursor: pointer;
`;

export const AvatarTooltipList = styled(Box)`
  max-width: 200px;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
`;

export const AdminAvatarGroup = styled(AvatarGroup)`
  .MuiAvatarGroup-avatar {
    width: 30px;
    height: 30px;
  }
`;
